// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__2fCVL","card":"Cards_card__1fN2x","infected":"Cards_infected__TsY8B","recovered":"Cards_recovered__1JMVF","deaths":"Cards_deaths__3iGPv"};